"use client";

import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  IconButton,
  IconButtonProps,
} from "@chakra-ui/react";
import {
  KeenSliderOptions,
  KeenSliderPlugin,
  useKeenSlider,
} from "keen-slider/react"; // using version 6.6.2
import { forwardRef } from "react";

export const Carousel = forwardRef<HTMLDivElement, FlexProps>(
  function Carousel(props, ref) {
    return (
      <Flex
        aria-roledescription="carousel"
        ref={ref}
        overflow="hidden"
        position="relative"
        userSelect="none"
        {...props}
      />
    );
  },
);

export const CarouselSlide = ({
  slideLength,
  idx,
  ...rest
}: BoxProps & { slideLength: number; idx: number }) => (
  <Box
    aria-label={`Slide ${idx + 1} of ${slideLength}`}
    aria-roledescription="slide"
    className="carousel__slide"
    position="relative"
    overflow="hidden"
    width="100%"
    minH="100%"
    {...rest}
  />
);

export const CarouselIconButton = (props: IconButtonProps) => (
  <IconButton
    variant="unstyled"
    boxSize="auto"
    minW="auto"
    display="inline-flex"
    fontSize={{
      base: "3xl",
      lg: "4xl",
    }}
    color={"gray.600"}
    _hover={{
      color: "blue.500",
      _disabled: { color: "gray.600" },
    }}
    _active={{ color: "blue.600" }}
    _focus={{ boxShadow: "none" }}
    _focusVisible={{ boxShadow: "outline" }}
    {...props}
  />
);

export const useCarousel = (
  options?: KeenSliderOptions,
  plugins?: KeenSliderPlugin[],
) => {
  const defaultOptions = { selector: ".carousel__slide" };
  return useKeenSlider<HTMLDivElement>(
    { ...defaultOptions, ...options },
    plugins,
  );
};
